export default __webpack_public_path__ + "img/benefits3.414b0d5f.svg";